var _style, _g, _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502.47 468.77",
    style: {
      enableBackground: "new 0 0 502.47 468.77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#231815;stroke-width:18;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#231815;stroke-width:18;stroke-miterlimit:10;}\r\n\t.st2{fill:#231815;stroke:#231815;stroke-width:8;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.94,436.94c0-63.21,0-126.42,0-189.63c0-67.46,0-134.92,0-202.38"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.13,217.74c76.71,30.25,163.93,7.3,192.63-38.88c22.88-36.82,6.67-85.38-32.57-110.28 c-37.45-23.77-88.66-21.39-107.95-20.5c-17.44,0.81-31.79,3.37-41.88,5.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 360.45,
    cy: 179.95,
    r: 14.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.88,431.74c54.39-75.72,93.95-130.69,103.2-144.37c1.56-2.31,6.17-9.22,12.26-9.17 c5.98,0.05,10.47,6.79,12.46,9.93c21.09,33.21,47.12,108.7,86.54,132.97c13.72,8.45,29.11,11.49,29.11,11.49 c4.15,0.82,17.21,3.08,33.7,0c9.81-1.83,23.11-5.98,39.83-17.62c28.64-19.93,70.89-49.33,72-97.28 c0.8-34.63-19.88-78.12-56.97-88.14c-25.75-6.96-48.23,5.25-52.56,7.72c-34.36,19.59-38.4,59.98-39.06,66.64 c-4.76,47.61,30.16,82.31,39.83,91.91c53,52.66,129.05,41.18,137.11,39.83c7.82-1.31,14.15-3.01,18.3-4.26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLogo);
export default __webpack_public_path__ + "static/media/myLogo.71c1ea6af25f362043725820ee3ef052.svg";
export { ForwardRef as ReactComponent };